module.exports = {"TXTCLI_Required":{"id":"TXTCLI_Required","defaultMessage":"Απαιτείται","track":"Required"}}